
/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.cart-item-loop');
};

window.CartSelection = {
  form: null,
  root: (window.Shopify && Shopify.routes && Shopify.routes.root) || '/',
  init(selector='form[action="/cart"]') {
    this.form = document.querySelector(selector);
    if(!this.form) return;
    this.bindEvents();
    this.syncSelectAll();
  },
  boxes() {
    return Array.from(this.form.querySelectorAll('.line-select'));
  },
  bindEvents() {
    const selectAll = this.form.querySelector('#select-all');
    const clearBtn = this.form.querySelector('.btn-clear-selected');
    if(selectAll){
      selectAll.addEventListener('change', e=>{
        this.boxes().forEach(b=>b.checked=e.target.checked);
      });
      this.boxes().forEach(b=>b.addEventListener('change',()=>this.syncSelectAll()));
    }
    if(clearBtn){
      clearBtn.addEventListener('click', e=>{
        e.preventDefault();
        this.clearSelected();
      });
    }
  },
  syncSelectAll() {
    const selectAll=this.form.querySelector('#select-all');
    if(!selectAll)return;
    const all=this.boxes();
    selectAll.checked=all.length && all.every(b=>b.checked);
  },
  async clearSelected() {
    const selected=this.boxes().filter(b=>b.checked);
    if(!selected.length) return;
    const updates={};
    selected.forEach(b=>{
      const wrap=b.closest('.cart-wrap');
      const v=wrap && wrap.querySelector('.product-quantity[data-variant]');
      const id=v && v.dataset && v.dataset.variant;
      if(id) updates[id]=0;
    });
    if(!Object.keys(updates).length) return;
    try{
      const r=await fetch(this.root+'cart/update.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({updates})
      });
      if(r.ok) location.reload();
      else console.error('Cart update failed',await r.text());
    }catch(err){ console.error(err); }
  }
};



Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = "<span class='money'>{{amount}}</span>";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

      jQuery.each(cart, function(key, value) {

        if (key === 'items') {
      
          if (value.length) {
            jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area").css({"display": "block"});
            jQuery(".cart-tempty-title").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<li class="cart-item"><div class="cart-image"><a href="' + item.url + '"><img src="' + item.image + '" alt="" class="img-fluid"></a></div><div class="cart-title"><h6><a href="' + item.url + '">' + item.title.substring(0, 50) +'</a></h6><div class="cart-pro-info"><div class="cart-qty-price"><span class="quantity">' + item.quantity + ' × </span><span class="price-box"><span class="new-price">' + Shopify.formatMoney(item.price, formatMoney) + '</span></span></div><div class="delete-item-cart"><a class="remove_from_cart" href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="icon-trash icons"></i></a></div></div></div></li>').appendTo(table);
              
            });
          }
          else {
            jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area").css({"display": "none"});
      jQuery(".cart-tempty-title").css({"display": "block"});
          }
        }
      });
    }
  }
  
  jQuery(".subtotal-price").html(Shopify.formatMoney(cart.total_price, formatMoney));
  jQuery(".bigcounter").html(cart.items.length);
  console.log(cart.items.length, " I am here");
  CartSelection.init();
  if(cart.item_count > 1){
   jQuery('.cart-count-desc').text('products'); 
  }else{
    jQuery('.cart-count-desc').text('product');
  }
  jQuery('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};


document.addEventListener('DOMContentLoaded',()=>CartSelection.init());
